import SimpleErrorMessage from 'components/InputsMex/containers/SimpleErrorMessage';
import { IndexColumn } from 'components/Table/Columns';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import useAsegurados from 'redux/hooks/emision/useAsegurados';
import ModalAddBeneficiario from '../Listado/ModalAddBeneficiario';

const BeneficiariosTable = ({ beneficiarios, setter }) => {
  const methods = useFormContext();

  const { getPorcentajes, catalogoBeneficiarios, mappParentescosBeneficiarios } =
    useAsegurados();
  const asegurado = methods.getValues();
  const porcentajes = getPorcentajes(beneficiarios);

  const onSubmit =
    ({ handleClose, methods }) =>
    (formData) => {
      handleClose();
      beneficiarios.push(formData);
      setter([...mappParentescosBeneficiarios(beneficiarios)]);
      methods.reset();
    };

  const header = (
    <div className="d-flex flex-row flex-wrap justify-content-between">
      <div className="align-self-center">
        <ModalAddBeneficiario
          accion="add"
          asegurado={asegurado}
          onSubmit={onSubmit}
          labelBtn="AGREGAR BENEFICIARIOS"
          beneficiarios={beneficiarios}
        />
        <SimpleErrorMessage name="beneficiarios" />
      </div>

      <div>
        <h6>
          Beneficiarios: {beneficiarios.length} de{' '}
          {catalogoBeneficiarios?.maxBeneficiarios}
        </h6>
      </div>

      <div>
        <h6>Porcentaje: {porcentajes?.actual}</h6>
      </div>
    </div>
  );

  const onSubmitEdit =
    ({ handleClose, methods }) =>
    (formData) => {
      const index = beneficiarios.findIndex((item) => item.uuid === formData.uuid);
      beneficiarios[index] = formData;
      setter([...mappParentescosBeneficiarios(beneficiarios)]);
      handleClose();
      methods.reset();
    };

  return (
    <DataTable
      value={beneficiarios}
      autoLayout
      className="p-datatable-gridlines"
      emptyMessage="No se han registrado beneficiarios"
      header={header}
    >
      {IndexColumn({
        header: 'Beneficiario',
        headerClassName: 'bg-cyan50 text-coreBlue',
      })}
      <Column
        field="nombres"
        header="Nombres"
        headerClassName="bg-cyan50 text-coreBlue"
        body={(rowData) => {
          return `${rowData.nombres} ${rowData.apellidoPaterno} ${rowData.apellidoMaterno}`;
        }}
      />
      {/* <Column field="apellidoPaterno" header="Apellido paterno" />
                <Column field="apellidoMaterno" header="Apellido materno" /> */}
      <Column field="rfc" header="RFC" headerClassName="bg-cyan50 text-coreBlue" />
      <Column
        field="parentescoLabel"
        header="Parentesco asegurado / beneficiario"
        headerClassName="bg-cyan50 text-coreBlue"
      />
      <Column
        field="porcentaje"
        header="Porcentaje"
        headerClassName="bg-cyan50 text-coreBlue"
      />
      {/* <Column
        header="Editar"
        body={(rowData) => {
          return (
            <ModalAddBeneficiario
              defaultValues={rowData}
              accion="edit"
              asegurado={asegurado}
              labelBtn="Editar"
              onSubmit={onSubmitEdit}
              allowCompleted={false}
              porcentajeEditar={Number(rowData?.porcentaje)}
              beneficiarios={beneficiarios}
            />
          );
        }}
      />
      <Column
        header="Eliminar"
        body={(rowData) => (
          <Button
            className="p-button-primary p-button-sm"
            label="Eliminar"
            onClick={() => {
              setter(beneficiarios.filter((item) => item.uuid !== rowData.uuid));
            }}
          />
        )}
      /> */}
      <Column
        header="Opciones"
        style={{ width: '220px', padding: '0 0.5rem' }}
        headerClassName="bg-cyan50 text-coreBlue"
        body={(rowData) => {
          const onClickEliminar = () => {
            const index = beneficiarios.indexOf(rowData);
            beneficiarios.splice(index, 1);
            methods.setValue('beneficiarios', beneficiarios);
          };
          return (
            <div className="d-flex flex-row flex-wrap justify-content-between">
              <ModalAddBeneficiario
                defaultValues={rowData}
                accion="edit"
                asegurado={asegurado}
                labelBtn="Editar"
                onSubmit={onSubmitEdit}
                allowCompleted={false}
                porcentajeEditar={Number(rowData?.porcentaje)}
                beneficiarios={beneficiarios}
              />
              <Button
                className="p-button-primary p-button-sm"
                label="Eliminar"
                onClick={() => {
                  setter(beneficiarios.filter((item) => item.uuid !== rowData.uuid));
                }}
              />
            </div>
          );
        }}
      />
    </DataTable>
  );
};

export default BeneficiariosTable;
